export default __webpack_public_path__ + "static/media/groovy-ale-thumb.bd2d4205.jpg";